import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { useHistory } from 'react-router-dom';

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  Grid,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@material-ui/core';

import {
  AssistanceDetails,
  VEHICLE_UBICATIONS,
} from '../../../../../constants/assistance.constant';
import { useAssistanceDataContext } from '../../../../../context/assistance/assistance.provider';
import { useAuthDataContext } from '../../../../../context/auth/auth.provider';
import { dataLayerPush } from '../../../../../helpers/dataLayerPush';
import useForm from '../../../../../helpers/useForm';
import {
  VEHICLES_QUERY,
  VEHICLES_QUERY_CONFIG,
  vehiclesQuery,
} from '../../../../../query/vehicles/vehicles';
import AssistanceSummaryValidation from './AssistanceSummary.validation';

const AssistanceSummary = () => {
  const { assistance_body, success, updateAssistanceBody, createAssistance } =
    useAssistanceDataContext();
  const { assistance_detail } = assistance_body;
  const history = useHistory();
  const [defaultValues] = useState({
    vehicle_id: assistance_body.vehicle_id,
    vehicle_location: assistance_body.vehicle_location,
    require_transfer: true,
  });

  const { data: vehicles } = useQuery(
    VEHICLES_QUERY,
    vehiclesQuery,
    VEHICLES_QUERY_CONFIG
  );
  const { user } = useAuthDataContext();

  useEffect(() => {
    if (success.assistance) {
      history.push('/assistance/' + success.assistance.id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [success]);

  const submitAssistance = () => {
    dataLayerPush('necesito_asistencia_confirmacion', user?.id);
    createAssistance();
  };

  const { values, errors, handleChange, handleSubmit } = useForm(
    submitAssistance,
    AssistanceSummaryValidation,
    defaultValues
  );

  useEffect(() => {
    updateAssistanceBody(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box my={3}>
          <Typography variant="h6">Resumen</Typography>
        </Box>
      </Grid>
      <Grid item xs={12} sm={9} md={8}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Datos del vehículo</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box my={2} mr={2}>
              <Typography variant="subtitle1">Vehículo</Typography>
              <FormControl
                fullWidth
                size="small"
                variant="outlined"
                error={!!errors['vehicle_id']}
              >
                <Select
                  value={values.vehicle_id}
                  onChange={handleChange}
                  id="vehicle_id"
                  name="vehicle_id"
                  displayEmpty
                  inputProps={{ 'aria-label': 'Without label' }}
                >
                  <MenuItem value="" disabled>
                    Seleccioná el vehículo
                  </MenuItem>
                  {vehicles.map((vehicle: any) => (
                    <MenuItem key={vehicle.id} value={vehicle.id}>
                      {vehicle.brand + ' ' + vehicle.model.split(' ')[0]} -
                      Patente {vehicle.license_plate}
                    </MenuItem>
                  ))}
                </Select>
                {errors['vehicle_id'] ? (
                  <FormHelperText>{errors['vehicle_id']}</FormHelperText>
                ) : null}
              </FormControl>
            </Box>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sm={9} md={8}>
        <Grid container>
          <Grid item xs={12}>
            <Typography variant="subtitle2">Detalles del traslado</Typography>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Box my={2} mr={2}>
              <Typography variant="subtitle1">
                Lugar de{' '}
                {assistance_detail === AssistanceDetails.VEHICLE_WONT_START ||
                assistance_detail === AssistanceDetails.SPARE_TIRE
                  ? 'asistencia'
                  : 'recogida'}
              </Typography>
              <TextField
                size="small"
                name="origin"
                fullWidth={true}
                id="origin"
                variant="outlined"
                value={assistance_body?.pickup_location?.description || ''}
                disabled
              />
            </Box>
          </Grid>
          {assistance_detail !== AssistanceDetails.VEHICLE_WONT_START &&
          assistance_detail !== AssistanceDetails.SPARE_TIRE ? (
            <>
              <Grid item xs={12} sm={6}>
                <Box my={2} ml={2}>
                  <Typography variant="subtitle1">Lugar de destino</Typography>
                  <TextField
                    size="small"
                    name="destiny"
                    fullWidth={true}
                    id="destiny"
                    variant="outlined"
                    value={assistance_body?.destiny_location?.description || ''}
                    disabled
                  />
                </Box>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box my={2} mr={2}>
                  <Typography variant="subtitle1">
                    Ubicación del vehículo
                  </Typography>
                  <FormControl fullWidth size="small" variant="outlined">
                    <Select
                      onChange={handleChange}
                      id="vehicle_location"
                      name="vehicle_location"
                      value={values.vehicle_location}
                    >
                      {VEHICLE_UBICATIONS.map((ubication: any) => (
                        <MenuItem key={ubication.value} value={ubication.value}>
                          {ubication.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>
            </>
          ) : null}
        </Grid>
      </Grid>
      <Grid item xs={12} sm={6}>
        <Box my={3}>
          <Button
            onClick={handleSubmit}
            disabled={!!Object.keys(errors).length}
            variant="contained"
            color="primary"
          >
            Confirmar asistencia
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default AssistanceSummary;
